import { Controller } from "@hotwired/stimulus"

// Disables a submit button until all required checkboxes within the form
// are checked. Apply on the form with a "submit" target on the button
// and action "change->submit-button-lock#toggle" on the checkbox(es).
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const allChecked = this.requiredCheckboxes.every(cb => cb.checked)
    this.submitTargets.forEach(btn => {
      btn.disabled = !allChecked
      btn.classList.toggle("opacity-50", !allChecked)
      btn.classList.toggle("cursor-not-allowed", !allChecked)
    })
  }

  get requiredCheckboxes() {
    return Array.from(this.element.querySelectorAll('input[type="checkbox"][required]'))
  }
}
